import { defineMessages } from 'react-intl'

export default defineMessages({
  submit: {
    id: 'form.label.submit',
    defaultMessage: 'Submit',
  },
  email: {
    id: 'form.label.email',
    defaultMessage: 'Email address',
  },
  first_name: {
    id: 'form.label.first_name',
    defaultMessage: 'First name',
  },
  middle_name: {
    id: 'form.label.middle_name',
    defaultMessage: 'Middle name (optional)',
  },
  last_name: {
    id: 'form.label.last_name',
    defaultMessage: 'Last name',
  },
  password: {
    id: 'form.label.password',
    defaultMessage: 'Password',
  },
  date_of_birth: {
    id: 'form.label.date_of_birth',
    defaultMessage: 'Date of birth',
  },
  date_of_birth_us: {
    id: 'form.label.date_of_birth_us',
    defaultMessage: 'Date of birth',
  },
  date_of_birth_v2: {
    id: 'form.label.date_of_birth_v2',
    defaultMessage: 'Date of birth',
  },
  current_gp: {
    id: 'form.label.current_gp',
    defaultMessage: 'Current GP practice',
  },
  postcode: {
    id: 'form.label.postcode',
    defaultMessage: 'Postcode',
  },
  zipcode: {
    id: 'form.label.zipcode',
    defaultMessage: 'ZIP code',
  },
  address_post_codeHelpText: {
    id: 'form.helptext.zipcode',
    defaultMessage: 'This helps us find providers in their area.',
  },
  address_post_code_v2HelpText: {
    id: 'form.helptext.zipcode_v2',
    defaultMessage:
      'This helps us connect you with healthcare providers in your area.',
  },
  gender: {
    id: 'form.label.gender',
    defaultMessage: 'Gender',
  },
  genderMale: {
    id: 'form.label.gender.male',
    defaultMessage: 'Male',
  },
  genderFemale: {
    id: 'form.label.gender.female',
    defaultMessage: 'Female',
  },
  phone_country_code: {
    id: 'form.label.phone_country_code',
    defaultMessage: 'Dialling code',
  },
  phone_number: {
    id: 'form.label.phone_number',
    defaultMessage: 'Phone number',
  },
  phone_number_v2: {
    id: 'form.label.phone_number_v2',
    defaultMessage: 'Phone number',
  },
  phone_number_v2HelpText: {
    id: 'form.helptext.phone_number_v2',
    defaultMessage: 'Include area code first, enter digits only',
  },
  date_of_birthHelpText: {
    id: 'form.helptext.date_of_birth',
    defaultMessage: 'For example: 21/09/1988',
  },
  date_of_birth_usHelpText: {
    id: 'form.helptext.date_of_birth_us',
    defaultMessage: 'For example: 09/21/1988',
  },
  date_of_birth_v2HelpText: {
    id: 'form.helptext.date_of_birth_v2',
    defaultMessage: 'You need to be 18 or older.',
  },
  passwordHelpText: {
    id: 'form.helptext.password',
    defaultMessage:
      'Minimum 8 characters with a number, uppercase and lowercase letter',
  },
  address_state_code: {
    id: 'form.label.address_state_code',
    defaultMessage: 'Province',
  },
  submitButtonLoading: {
    id: 'form.label.submitbuttonloading',
    defaultMessage: 'Loading',
  },
  familyPageDateOfBirthLabel: {
    id: 'familymodal.dateofbirthlabel',
    defaultMessage: 'What is their date of birth?',
  },
  familyPageGenderLabel: {
    id: 'familymodal.genderlabel',
    defaultMessage: 'What is their gender?',
  },
  familyPageEmailLabel: {
    id: 'familymodal.emaillabel',
    defaultMessage: 'What is their email?',
  },
  emailHelpText: {
    id: 'form.helptext.email',
    defaultMessage:
      'Enter an email for receiving reminders, notifications, and notes',
  },
  insurerId: {
    id: 'eligibilitycheck.insurerid',
    defaultMessage: 'Insurance Provider',
  },
  planUuid: {
    id: 'eligibilitycheck.planuuid',
    defaultMessage: 'Insurance Plan',
  },
  externalInsuranceId: {
    id: 'eligibilitycheck.externalinsuranceid',
    defaultMessage: `{person, select,
      first {Add your insurance member ID}
      other {Add their member ID}
    }`,
  },
})
